import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';

// Create QueryClient instance for TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false, // Individual queries will override this
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div>
          <AppRouter />
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
